<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('class_name')" v-model="levelFormData.name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationLevelButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addLevel">{{ $t('add_level') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('membership_level')" v-model="levelSearchParams.level" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="levelSearchParams.isActive" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadLevels(1, null,true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="levelDataContainer" :title="$t('levels')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-member-level-list
        :levels="levels"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-member-level-list>

      <template slot="footer">
        <paginate
          :total="levelPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadLevels"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import Level from '@/models/Level'
import SharedUserConfigurationMemberLevelList from '@/views/Shared/Configuration/Member/Levels/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Member.Levels',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationMemberLevelList
  },
  data () {
    return {
      levelsEdit: {},
      levels: {},
      levelPages: 1,
      levelFormData: {
        name: '',
        is_active: '',
        id: ''
      },
      levelFormErrors: {},
      itemPerPage: null,
      levelSearchParams: {
        level: typeof this.$route.query.level !== 'undefined' ? this.$route.query.level : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadLevels(this.initialPage, null, false, true)
  },
  methods: {
    async loadLevels (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#levelDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: {...this.levelSearchParams, page, itemPerPage}})
      }
      const response = await Level.all({ ...this.levelSearchParams, page, itemPerPage })
      this.levels = response.data.data.levels
      this.levelPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#levelDataContainer > .con-vs-loading')
    },
    async addLevel (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationLevelButton', scale: 0.45})
      if (this.levelFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_member_level_error_message'),
          confirmButton: this.$t('confirm')
        })

        this.$store.dispatch('setIsFormInProgress', false)

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await Level.save(this.levelFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadLevels(1, this.itemPerPage)
        this.levelFormData = {
          name: '',
          is_active: '',
          id: ''
        }
        this.levelFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationLevelButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.levels[key].is_active === 1) {
          this.levels[key].is_active = 0
        } else {
          this.levels[key].is_active = 1
        }
        await Level.update(this.levels[key])
        this.levels[key].levelFormErrors = {}
      } catch (e) {
        this.levels[key].levelFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.levels[key].edit = true
      const editElem = this.levels[key]
      const editObj = {
        name: editElem.name
      }
      this.levelsEdit[key] = editObj
    },
    async cancel (key) {
      this.levels[key].name = this.levelsEdit[key].name
      this.levels[key].edit = false
      this.levels[key].levelFormErrors = {}
      delete this.levelsEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('level_update_confirmation_title'),
          text: this.$t('level_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationLevelButton${ id }`, scale: 0.45})
          await Level.update(this.levels[key])
          this.levels[key].edit = false
          this.levels[key].levelFormErrors = {}
          this.$vs.loading.close(`#updateConfigurationLevelButton${ id } > .con-vs-loading`)
        }
      } catch (e) {
        this.levels[key].levelFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateConfigurationLevelButton${ id } > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Level.destroy(id)
        this.loadLevels(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationLevelButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
